import SmallDelete from '@/components/atom/icon/SmallDelete';
import { DIRECT_SEARCH_KEYWORD_TYPE } from '@/components/templates/mobile/home/home-search-template/components/search-result';
import { QnaSearchKeywordList } from '@/types/qna';
import React from 'react';

export interface RecentKeyWordProps {
  recentKeywordViewData: QnaSearchKeywordList;
  onSearchDirectKeyword: (key: string, type: DIRECT_SEARCH_KEYWORD_TYPE) => void;
  onDeleteItemRecentKeyword: (keyword: string) => void;
  onDeleteAllRecentKeyword: () => void;
}

const RecentKeyWord = ({
  recentKeywordViewData,
  onSearchDirectKeyword,
  onDeleteItemRecentKeyword,
  onDeleteAllRecentKeyword,
}: RecentKeyWordProps) => {
  return (
    <>
      {!!recentKeywordViewData.length && (
        <div className={'border-gray-100 border-b-[8px]'}>
          <div className='flex justify-between'>
            <span className='typography-ui-13m items-center px-[24px] py-[12px] text-gray-600'>최근 검색어</span>
            <button
              className='typography-ui-13m items-center px-[24px] py-[12px] text-gray-400'
              onClick={onDeleteAllRecentKeyword}
            >
              전체 삭제
            </button>
          </div>
          <div className='flex flex-wrap gap-[8px] px-[24px] py-[12px]'>
            {recentKeywordViewData.map((keyword) => (
              <div
                key={keyword}
                className='typography-ui-13m inline-flex h-[38px] items-center justify-center rounded-[40px] border-[1px] border-gray-100 border-solid bg-white px-[15px] py-[8px] text-gray-600'
              >
                <div
                  role='presentation'
                  className='typography-ui-15m cursor-pointer text-gray-700'
                  onClick={() => onSearchDirectKeyword(keyword, DIRECT_SEARCH_KEYWORD_TYPE.RECENT)}
                >
                  {keyword}
                </div>
                <button
                  type='button'
                  className='z-[2] ml-[4px] border-none p-0'
                  onClick={() => onDeleteItemRecentKeyword(keyword)}
                >
                  <SmallDelete color='#6B7280' size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
export default RecentKeyWord;
